export default function VisitorBadgePreview({
  schoolName = 'School',
  visitorType = 'Visitor',
  fullName = 'Visitor name',
  destination = '',
  visitReason = '',
  dateLabel = 'Date',
  timeLabel = 'Time',
  badgeNumber = 'Assigned at check-in',
  portraitSrc = '',
}) {
  return (
    <div className="vis-badge" aria-label="Badge preview">
      <div className="vis-badge-top">
        <strong>{schoolName}</strong>
        <span>Car-Pool</span>
      </div>
      <div className="vis-badge-body">
        {portraitSrc ? (
          <img className="vis-badge-photo" src={portraitSrc} alt="" />
        ) : (
          <div className="vis-badge-photo vis-badge-photo-empty" />
        )}
        <div className="vis-badge-copy">
          <div className="vis-badge-type">{visitorType}</div>
          <div className="vis-badge-name">{fullName || 'Visitor name'}</div>
          <div className="vis-badge-lines">
            <div><b>Visiting:</b> {destination || '—'}</div>
            <div><b>Purpose:</b> {visitReason || '—'}</div>
          </div>
        </div>
      </div>
      <div className="vis-badge-when">{dateLabel} • Check-in {timeLabel}</div>
      <div className="vis-badge-number">Badge #{badgeNumber} • Valid today only</div>
    </div>
  );
}
